import type { EditableOrder } from '@getvim-adapter/api';

export const editableOrder: EditableOrder = {
  basicInformation: {
    notes: {
      isEditable: true,
      reason: 'Mock Adapter Data',
    },
  },
  targetProvider: {
    isEditable: true,
    reason: 'Mock Adapter Data',
  },
};
